import { __exports as htmlIdentifier } from './_virtual-htmlIdentifier.js';

var hasRequiredHtmlIdentifier;

function requireHtmlIdentifier () {
	if (hasRequiredHtmlIdentifier) return htmlIdentifier;
	hasRequiredHtmlIdentifier = 1;

	Object.defineProperty(htmlIdentifier, "__esModule", {
	  value: true
	});
	htmlIdentifier.HTMLIdentifier = void 0;
	class HTMLIdentifier {
	  identifyHTML(html) {
	    const re = new RegExp(/<[a-z][\s\S]*>/);
	    return re.test(html);
	  }
	}
	htmlIdentifier.HTMLIdentifier = HTMLIdentifier;
	
	return htmlIdentifier;
}

export { requireHtmlIdentifier as __require };
//# sourceMappingURL=vp-tokenized-fragment-build-services-htmlIdentifier.js.map
